export default {"signUpForm":"_6YxUa","buttonSection":"ONXdt"};